import React, { Component } from 'react';
import DataTable from 'react-data-table-component';
import { Modal, Button } from "react-bootstrap";
import axios from 'axios';
import apiUrl from '../apiUrlConstant';
import styled from 'styled-components';
import datatableOptions from '../layout/datatableConstants';
import moment from 'moment';
import { debounce } from 'lodash';
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import SimpleReactValidator from "simple-react-validator";
import { faChevronRight, faCogs, faPen, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #003970;
`;

const statusOptions = [
  { value: '', label: 'All Status' },
  { value: 'completed', label: 'Completed' },
  { value: 'ongoing', label: 'Ongoing' },
  { value: 'overdue', label: 'Overdue' }
];

class TaskList extends Component {
  constructor(props) {
    super(props);

    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });

    this.state = {
      taskLists: [],
      totalRows: 10,
      loading: false,
      filterText: '',
      statusFilter: '', // Added for status filter
      perPage: 10,
      page: 1,
      editModalFlag: false,
      activeTaskId: null,
      activeTaskData: {},
      editType: ''
    };

    this.handlePageChange = this.handlePageChange.bind(this);
    this.handlePerRowsChange = this.handlePerRowsChange.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.fetchTasks = this.fetchTasks.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.openModal = this.openModal.bind(this);
    this.handleStatusFilterChange = this.handleStatusFilterChange.bind(this); // Added for status filter
  }

  componentDidMount() {
    this.fetchTasks();
  }

  handlePageChange(page) {
    this.fetchTasks(this.state.filterText, this.state.statusFilter, page);
  }

  handlePerRowsChange(newPerPage, page) {
    this.setState({ perPage: newPerPage });
    this.fetchTasks(this.state.filterText, this.state.statusFilter, page);
  }

  clearFilter() {
    this.setState({ filterText: '', statusFilter: '' }, () => {
      this.fetchTasks();
    });
  }

  handleFilter(event) {
    const filterValue = event.target.value;
    this.setState({ filterText: filterValue }, () => {
      debounce(() => {
        this.fetchTasks(this.state.filterText, this.state.statusFilter, this.state.page);
      }, 300)();
    });
  }

  handleStatusFilterChange(event) {
    const statusValue = event.value;
    this.setState({ statusFilter: statusValue }, () => {
      this.fetchTasks(this.state.filterText, this.state.statusFilter, this.state.page);
    });
  }

  openModal() {
    this.setState({ editModalFlag: true });
  }

  fetchTasks(filterText = '', statusFilter = '', page = 1) {
    this.setState({ loading: true });

    axios
      .get(`${apiUrl.apiUrl.url}/leads/task-list`, {
        params: {
          per_page: this.state.perPage,
          page: page,
          filter: filterText,
          status: statusFilter, // Pass the status filter value to the API
        },
      })
      .then((response) => {
        if (response.data.status === 'success') {
          this.setState({
            taskLists: response.data.data,
            totalRows: response.data.total,
            loading: false,
            page: page,
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  render() {

    const columns = [
      {
        name: 'Lead Title',
        selector: 'lead_title',
        sortable: true,
        cell: (record) => (
          <Link
            to={`/leads/view/${record.lm_leads_id}`}
            target="_blank"
          >
            {record.lead_title}
          </Link>
        )
      },
      {
        name: 'Task',
        selector: 'title',
        sortable: true,
        cell: (record) => (
          <Link
            to="#"
            onClick={() => {
              this.setState(
                {
                  editModalFlag: true,
                  activeTaskId: record.id,
                  editType: 'view',
                },
                () => {
                  const activeTaskData = this.state.taskLists.find(item => item.id === this.state.activeTaskId);
                  activeTaskData.reminder_date_time = activeTaskData.reminder_date_time ? activeTaskData.reminder_date_time : '';
                  activeTaskData.due_date = activeTaskData.due_date ? moment(activeTaskData.due_date).format('YYYY-MM-DD') : '';
                  this.setState({ activeTaskData });
                }
              );
            }}
          >
            {record.title}
          </Link>
        ),
      },
      {
        name: 'Status',
        selector: 'status',
        sortable: true,
        cell: (record) => (
          record.status.replace(/\b\w/g, char => char.toUpperCase())
        )
      },
      {
        name: 'Assign To',
        selector: 'user_name',
        sortable: true,
        cell: (record) => (
          record.user_name.replace(/\b\w/g, char => char.toUpperCase())
        )
      },
      {
        name: 'Due Date',
        selector: 'due_date',
        sortable: true,
        cell: (record) => moment(record.due_date).format('DD-MMM-YYYY'),
      },
      {
        name: 'Added On',
        selector: 'created_on',
        sortable: true,
        cell: (record) => moment(record.created_on).format('DD-MMM-YYYY'),
      },
      {
        name: 'Action',
        cell: (record) => (
          record.status !== 'completed' && (
            <div className='d-flex align-items-center gap-2'>
              <button
                title='Update Status'
                className='bg-white'
                onClick={() => {
                  this.setState(
                    {
                      editModalFlag: true,
                      activeTaskId: record.id,
                      editType: 'status',
                    },
                    () => {
                      const activeTaskData = this.state.taskLists.find(item => item.id === this.state.activeTaskId);
                      activeTaskData.reminder_date_time = activeTaskData.reminder_date_time ? activeTaskData.reminder_date_time : '';
                      this.setState({ activeTaskData });
                    }
                  );
                }}
              >
                <FontAwesomeIcon icon={faCogs} color='#7FD629' />
              </button>
              <span>|</span>
              <button
                title='Edit Task'
                className='bg-white'
                onClick={() => {
                  this.setState(
                    {
                      editModalFlag: true,
                      activeTaskId: record.id,
                      editType: 'all',
                    },
                    () => {
                      const activeTaskData = this.state.taskLists.find(item => item.id === this.state.activeTaskId);
                      activeTaskData.reminder_date_time = activeTaskData.reminder_date_time ? activeTaskData.reminder_date_time : '';
                      activeTaskData.due_date = activeTaskData.due_date ? moment(activeTaskData.due_date).format('YYYY-MM-DD') : '';
                      this.setState({ activeTaskData });
                    }
                  );
                }}
              >
                <FontAwesomeIcon icon={faPen} color='orange' />
              </button>
            </div>
          )
        )
      },
    ];

    return (
      <>
        <div className="parentContainer">
          <div className="absoluteItemForTopBar">
            <div className="new_breadcrumbs_design">
              <ul className="d-flex align-items-center gap-3 p-0 m-0">
                <li>
                  <Link to="/leads" style={{ color: "#000", textDecoration: "none" }}>Lead</Link>
                </li>
                <li><FontAwesomeIcon icon={faChevronRight} /></li>
                <li>
                  <Link to="#">Task List</Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="masterContainer p-0">
            <div className='unitFormContainerNew '>
              <div className="row m-0">
                <div className="col-8 ps-0">
                  <div className="d-flex align-items-center gap-2">
                    {/* <TextField type="text"/> */}
                    <input placeholder="Filter by Task" type="text" value={this.state.filterText} onChange={this.handleFilter} />
                    <Select
                      value={this.state.statusValue}
                      onChange={this.handleStatusFilterChange}
                      options={statusOptions}
                      className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                    />

                  </div>
                </div>
              </div>
            </div>

            <div className="tableContainer">
              <DataTable
                title=""
                columns={columns}
                data={this.state.taskLists}
                customStyles={datatableOptions.datatableOptions.customStyle}
                progressPending={this.state.loading}
                pagination
                paginationServer
                paginationTotalRows={this.state.totalRows}
                onChangeRowsPerPage={this.handlePerRowsChange}
                onChangePage={this.handlePageChange}
                paginationComponentOptions={datatableOptions.datatableOptions.paginationOptions}
              />
            </div>

            <Modal show={this.state.editModalFlag} className='customModalFroTaskAndComment' onHide={() => this.setState({ editModalFlag: false })} backdrop="static">
              <Modal.Header closeButton>
                <Modal.Title>{this.state.editType === "status" ? "Update Status" : this.state.editType === "all" ? "Edit Task" : ""} </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Formik
                  enableReinitialize={true}
                  initialValues={this.state.activeTaskData}
                  onSubmit={(values, actions) => {
                    if (!this.validator.allValid()) {
                      this.validator.getErrorMessages();
                      this.validator.showMessages();
                      return false;
                    }

                    values.task_id = this.state.activeTaskId;
                    values.update_type = this.state.editType;

                    axios({
                      method: "post",
                      url: `${apiUrl.apiUrl.url}/leads/update-task`,
                      data: values,
                    }).then((response) => {
                      if (response.data.status === 'success') {
                        setTimeout(() => {
                          this.setState({ editModalFlag: false });
                          this.fetchTasks();
                        }, 1000);
                      } else {
                        actions.setSubmitting(false);
                        actions.setErrors(response.data);
                      }
                    });

                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting
                  }) => (
                    <>
                      <div className="unitFormContainerNew">
                        <Form autoComplete="off"  onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault(); // Prevent form submission on Enter key press
                                        }
                                    }} onSubmit={handleSubmit}>
                          <div className="newGridSectionParent">
                            <div className="newGridSectionForFormMain newGridSectionForFormMainOneFr">
                              {this.state.editType === 'status' ? (
                                <>
                                  <div className="newGridSectionInner">
                                    <label>Select Status <span className="astrik">*</span></label>
                                    <div className="position-relative">
                                      <Field as="select" name="status" onChange={handleChange}>
                                        <option value="">Select Status</option>
                                        <option value="completed">Complete</option>
                                      </Field>
                                      {this.validator.message("Status", values.status, "required", { className: "text-danger" })}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>Comment <span className="astrik">*</span></label>
                                    <div className="position-relative">
                                      <Field as="textarea" name="comment" onChange={handleChange} />
                                      {this.validator.message("Comment", values.comment, "required", { className: "text-danger" })}
                                    </div>
                                  </div>
                                </>
                              ) : this.state.editType === 'view' ? (
                                <>
                                  <div className="newGridSectionInner">
                                    <label>Lead Title</label>
                                    <div className="position-relative">
                                      <span>{values.lead_title}</span>
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>Task</label>
                                    <div className="position-relative">
                                      <span>{values.title}</span>
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>Assign To</label>
                                    <div className="position-relative">
                                      <span>{values.user_name}</span>
                                    </div>
                                  </div>

                                  {values.description && (
                                    <div className="newGridSectionInner">
                                      <label>Description</label>
                                      <div className="position-relative">
                                        <span>{values.description}</span>
                                      </div>
                                    </div>
                                  )}

                                  <div className="newGridSectionInner">
                                    <label>Due Date</label>
                                    <div className="position-relative">
                                      <span>{ values.due_date ? moment(values.due_date).format("DD-MMM-YYYY") : ''}</span>
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>Status</label>
                                    <div className="position-relative">
                                      <span>{values.status}</span>
                                    </div>
                                  </div>

                                  {values.reminder_date_time && (
                                    <div className="newGridSectionInner">
                                      <label>Reminder Date and Time</label>
                                      <div className="position-relative">
                                        <span>{ values.reminder_date_time ? moment(values.reminder_date_time).format("DD-MMM-YYYY | hh:mm A") : '' }</span>
                                      </div>
                                    </div>
                                  )}

                                </>
                              ) : (
                                <>
                                  <div className="newGridSectionInner">
                                    <label>Task <span className="astrik">*</span></label>
                                    <div className="position-relative">
                                      <Field type="text" name="title" onChange={handleChange} />
                                      {this.validator.message("Task", values.title, "required", { className: "text-danger" })}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>Description</label>
                                    <div className="position-relative">
                                      <Field as="textarea" name="description" onChange={handleChange} />
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>Due Date <span className="astrik">*</span></label>
                                    <div className="position-relative">
                                      <Field type="date" name="due_date" onChange={handleChange} />
                                      {this.validator.message("Due date", values.due_date, "required", { className: "text-danger" })}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>Reminder Date and Time</label>
                                    <div className="position-relative">
                                      <Field type="datetime-local" name="reminder_date_time" onChange={handleChange} />
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                            {this.state.editType !== 'view' && (
                              <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                                
                                <button type="button"  className="cancel_button" onClick={()=>{ this.setState({editModalFlag:false}); }}>
                                  Cancel
                                </button>

                                <Button type="submit" disabled={isSubmitting} className="update_button">
                                  {isSubmitting && <FontAwesomeIcon icon={faSpinner} className="spinner-icon" />} Update
                                </Button>

                                
                              </div>
                            )}
                          </div>
                        </Form>
                      </div>
                    </>
                  )}
                </Formik>
              </Modal.Body>
            </Modal>
          </div>
        </div>
      </>
    );
  }
}

export default TaskList;
